import { errorToastify } from "../../util/toast";
import { http } from "./common";
import ToastMessage from "../../common/toastMessage/ToastMessage";
import React from "react";

export const GetPatientDetails = async (claimId: string) => {
    try {
        const json = await http.get('/api/v1/PatientDetail/' + claimId);
        return json;
    } catch (error: any) {
        errorToastify(
            React.createElement(ToastMessage, {
                errorMessage: error?.payload?.error || "Something went wrong",
                innerException: error?.payload?.innerException,
                errorDetails: error?.payload?.errorDetails
            })
        );
        return null;
    }
};

export const fetchResources = async (url, patientId, encounterId?, cursor?) => {
    let endpoint = url + patientId;
    
    if (encounterId) {
        endpoint += '?encounter=' + encounterId;
    }
    
    if (cursor) {
        endpoint += (encounterId ? '&' : '') + cursor;
    }
    try{
        const json = await http.get(endpoint);
        return json;
    }catch (error){
        errorToastify(
            React.createElement(ToastMessage, {
                errorMessage: error?.payload?.error || "Something went wrong",
                innerException: error?.payload?.innerException,
                errorDetails: error?.payload?.errorDetails
            })
        );
        return null;
    }
}